import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveFileUrl as fileUrl } from "@/libs/fileUrl";
export default {
  props: {
    type: Number,
    item: Object
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {
      img: require("../../assets/collegeImg/pic.png")
    };
  },
  created: function created() {},
  methods: {
    lookDetails: function lookDetails(e) {
      window.open(e);
    }
  }
};